import BookIndex from "components/shared/book/list";
import SharedReactTable from "components/shared/reactTable";
import { rowIndexColumn } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import React from "react";
import { clearIcon, delItem, editIcon } from "sources/books/distributionBidSources";

export class DistributionBidSources extends BookIndex {
    get tableColumns() {
        return [
            rowIndexColumn,
            { Header: "ID", accessor: "id", width: 100, filterable: true, filterType: "int" },
            {
                Header: "Название",
                accessor: "name",
                filterable: true,
                sortable: true,
            },
            {
                Header: "Ссылка на страницу базы знаний",
                accessor: "knowledgeBaseUrl",
                filterable: true,
                sortable: true,
                Cell: ({ value }) => (
                    <a href={value} rel="noopener noreferrer" target="_blank" className="b-table__source-label">
                        {value}
                    </a>
                ),
            },
            {
                Header: "Ссылка на логотип",
                accessor: "iconUrl",
                sortable: false,
                Cell: ({ value, row: { original } }) => {
                    return (
                        <div>
                            {value && (
                                <>
                                    <img src={value} className="b-table__source-icon mr-1" alt={original.name || ""} />
                                    <span className="b-table__source-label text-muted">{value}</span>
                                </>
                            )}
                            <div className="d-block">
                                <div
                                    className="btn btn-xs btn-outline-primary mr-1"
                                    onClick={this.editLogo.bind(this, original.id)}
                                >
                                    {value ? "Изменить" : "Добавить"}
                                </div>
                                {value && (
                                    <div
                                        className="btn btn-xs btn-outline-danger"
                                        onClick={this.deleteLogo.bind(this, original.id)}
                                    >
                                        Удалить
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                },
            },
            {
                Header: "Действия",
                sortable: false,
                notExportable: true,
                id: "action",
                Cell: ({ row: { original } }) => this.actions(original),
            },
        ];
    }

    actions = (data) => {
        return (
            <div className="d-block">
                <div className="btn btn-xs btn-outline-primary mr-1" onClick={this.editSource.bind(this, data)}>
                    Изменить
                </div>
                <div className="btn btn-xs btn-outline-danger" onClick={this.deleteSource.bind(this, data.id)}>
                    Удалить
                </div>
            </div>
        );
    };

    editSource = (data) =>
        this.props.modal({
            name: "distributionBidSourcesForm",
            windowMod: "wide",
            title: "Редактирование источника",
            mergeParams: this.props.mergeParams,
            data,
        });

    editLogo = (sourceId) => {
        this.props.modal({
            name: "fileUpload",
            title: "Загрузка логотипа",
            propName: "file",
            uploadFile: (params) => {
                params.body.append("sourceId", sourceId);

                return editIcon(params);
            },
            action: () => {
                this.props.mergeParams({});
            },
        });
    };

    deleteLogo = (id) =>
        this.props.modal({
            name: "confirm",
            title: "Удаление логотипа",
            text: "Вы уверены, что хотите удалить логотип?",
            buttons: {
                confirm: "Удалить",
            },
            action: () => clearIcon({ id }).then(() => this.props.mergeParams({})),
        });

    deleteSource = (id) =>
        this.props.modal({
            name: "confirm",
            title: "Удаление источника",
            text: "Вы уверены, что хотите удалить источник?",
            buttons: {
                confirm: "Удалить",
            },
            action: () => delItem({ id }).then(() => this.props.mergeParams({})),
        });

    renderListComponent = () => <SharedReactTable {...this.props} columns={this.state.tableColumns} />;

    renderCreateButton = () => {
        const { modal, mergeParams } = this.props;
        const action = () =>
            modal({
                name: "distributionBidSourcesForm",
                windowMod: "wide",
                title: "Добавление источника",
                mergeParams,
            });
        return (
            <a className="btn btn-brand btn-sm" onClick={action}>
                Добавить платформу
            </a>
        );
    };
}

export default tableContainer(DistributionBidSources, "distribution-bid-sources");
